















































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { QDialog } from 'quasar'

@Component
export default class Dialog extends Vue {
  // inside = false

  @Prop()
  readonly title!: string

  @Prop()
  readonly message!: string

  @Prop()
  readonly btnLeft!: string

  @Prop({ default: 'white' })
  readonly btnLeftColor!: string

  @Prop()
  readonly btnMiddle!: string

  @Prop({ default: 'info' })
  readonly btnMiddleColor!: string

  @Prop()
  readonly btnRight!: string

  @Prop({ default: 'info' })
  readonly btnRightColor!: string

  @Prop()
  readonly btnBottom!: string

  @Prop({ default: 'info' })
  readonly btnBottomColor!: string

  @Ref()
  readonly dialog!: QDialog

  show () {
    this.dialog.show()
    this.$nextTick(() => {
      this.dialog.focus()
    })
  }

  hide () {
    this.dialog.hide()
  }
}
